import React from 'react';

export default props => <div className='form-group'>
    <label>{props.label}</label>
    <div style={{
        border: '2px dashed #b8c9db',
        borderRadius: 10,
        padding: 18,
        background: '#f8fafc'
    }}>
        <input
            type='file'
            className='form-control-file'
            accept={props.accept}
            multiple={props.multiple}
            onChange={evento => props.onChange(
                Array.from(evento.target.files || [])
            )}
        />
        <small className='text-muted'>{props.ajuda}</small>
    </div>
</div>;
